import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';
import { ACTIVITY_LOG } from '../../../constants/define/translation';

interface ActivityPageHeaderProps {
  //
}

export const ActivityPageHeader = (props: ActivityPageHeaderProps) => {
  const { t } = useTranslation(ACTIVITY_LOG);

  return <ContentPageHeader title={t('title')} />;
};
